import { paths } from '@organization/router'
import { Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { TeamsTableContainer, UsersTableContainer } from '../components'

enum TabKeys {
  USERS = 'users',
  TEAMS = 'teams'
}

export const UsersPage = () => {
  const { t } = useTranslation()
  const { tab = 'users' } = useParams()
  const navigate = useNavigate()

  const tabPath: Record<TabKeys, string> = {
    [TabKeys.USERS]: paths.users.root,
    [TabKeys.TEAMS]: paths.teams.root
  }

  const onTabClick = (key: TabKeys) => navigate(tabPath[key])

  const items = [
    {
      label: t('common.users'),
      key: TabKeys.USERS,
      children: <UsersTableContainer />
    },
    {
      label: t('common.teams'),
      key: TabKeys.TEAMS,
      children: <TeamsTableContainer />
    }
  ]

  return (
    <Tabs
      defaultActiveKey={tab}
      onTabClick={(value) => onTabClick(value as TabKeys)}
      items={items}
    />
  )
}
